module.exports = __webpack_public_path__ + "img/grade0.042886c3.png";